import EssayGradingView from "@features/essay-grading/view/essay-grading-view";

const EssayGrading = () => {
  return <EssayGradingView />;
};

export default EssayGrading;
